import { jsx as r } from "react/jsx-runtime";
import { aX as u } from "../../vendor-EQDp64ng.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as g } from "../../utils/omitStyleRenderProps/index.js";
import { ToggleButton as m } from "../ToggleButton/index.js";
import '../../assets/index63.css';const c = "_toggleButtonGroup_1h98o_1", l = {
  toggleButtonGroup: c
};
function G({
  items: p,
  isDisabled: t,
  size: e = "md",
  ...n
}) {
  return /* @__PURE__ */ r(
    u,
    {
      ...g(n),
      className: l.toggleButtonGroup,
      "data-component": "ToggleButtonGroup",
      isDisabled: t,
      children: p.map((o) => /* @__PURE__ */ r(
        m,
        {
          ...o,
          isDisabled: o.isDisabled || t,
          size: e
        },
        o.id
      ))
    }
  );
}
export {
  G as ToggleButtonGroup
};
